/* eslint no-param-reassign: "off" */
import moment from 'moment';

import * as types from './mutation-types';

export default {
  [types.ADD_ANALYTICS_DATE]: (state, payload) => {
    state.selectedDate = moment(state.selectedDate).add(payload.amount, payload.period);
  },

  [types.SUBTRACT_ANALYTICS_DATE]: (state, payload) => {
    state.selectedDate = moment(state.selectedDate).subtract(payload.amount, payload.period);
  },

  [types.SET_ANALYTICS_DATE]: (state, payload) => {
    state.selectedDate = moment(payload.date);
  },

  [types.SET_ANALYTICS_PERIOD]: (state, payload) => {
    state.selectedPeriod = payload.period;
  },

  [types.SET_ANALYTICS_FILTER]: (state, payload) => {
    state.selectedFilter = payload.filter;
  },

  [types.SET_ANALYTICS_TIMESLOT]: (state, payload) => {
    state.selectedTimeslot = payload.timeslot;
  },

  [types.GET_ANALYTICS_CHARTS_REQUEST]: state => {
    state.loadingCharts = true;
    state.loadingChartsFailed = false;
    state.loadingChartsSucceeded = false;
  },

  [types.GET_ANALYTICS_CHARTS_FAILURE]: (state, error) => {
    state.loadingCharts = false;
    state.loadingChartsFailed = true;
    state.loadingChartsError = error;
    state.loadingChartsSucceeded = false;
  },

  [types.GET_ANALYTICS_CHARTS_SUCCESS]: (state, response) => {
    state.loadingCharts = false;
    state.loadingChartsSucceeded = true;
    state.chartsData = response.data;
    state.loadingChartsFailed = false;
  },

  [types.GET_ANALYTICS_MAIN_CHART_REQUEST]: state => {
    state.loadingMainChart = true;
    state.loadingMainChartFailed = false;
    state.loadingMainChartSucceeded = false;
  },

  [types.GET_ANALYTICS_MAIN_CHART_FAILURE]: (state, error) => {
    state.loadingMainChart = false;
    state.loadingMainChartFailed = true;
    state.loadingMainChartsError = error;
  },

  [types.GET_ANALYTICS_MAIN_CHART_SUCCESS]: (state, response) => {
    state.loadingMainChart = false;
    state.loadingMainChartSucceeded = true;
    state.mainChartData = response.data;
  },

  [types.SET_ANALYTICS_MAIN_LEGEND]: (state, payload) => {
    state.showMainLegend = payload.option;
  },

  [types.GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST]: state => {
    state.loadingCampaignReport = true;
    state.loadingCampaignReportFailed = false;
    state.loadingCampaignReportSucceeded = false;
  },

  [types.GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE]: (state, error) => {
    state.loadingCampaignReport = false;
    state.loadingCampaignReportFailed = true;
    state.loadingCampaignReportError = error;
  },

  [types.GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS]: (state, response) => {
    state.loadingCampaignReport = false;
    state.loadingCampaignReportSucceeded = true;
    state.campaignReportData = response.data;
  },

  [types.GET_ANALYTICS_CAMPAIGN_LIST_REQUEST]: state => {
    state.loadingCampaignListCharts = true;
    state.laodingCampaignListChartsFailed = false;
    state.loadingCampaignListChartsSucceeded = false;
  },

  [types.GET_ANALYTICS_CAMPAIGN_LIST_FAILURE]: (state, error) => {
    state.loadingCampaignListCharts = false;
    state.loadingCampaignReportFailed = true;
    state.loadingCampaignListChartsError = error;
  },

  [types.GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS]: (state, response) => {
    state.loadingCampaignListCharts = false;
    state.loadingCampaignListChartsSucceeded = true;
    state.campaignListChartsData = response.data;
  },

  [types.SET_ANALYTICS_LIVE_STREAM_STATS]: (state, data) => {
    state.liveStreamingStates = data;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/analytics/mutations.js